import React from "react";
// import PropTypes from "prop-types";
import styles from "./styles/VideoControl.module.css";
import { formatTimeHMS } from "@helpers";
import { useState } from "react";
import clsx from "clsx";
import Slider from "rc-slider";

const VideoControl = (props) => {
  const {
    state,
    totalTimes,
    onPlayPause,
    onRewind,
    onFastForward,
    onMuted,
    onChangeVolume,
    onChangePlaybackRate,
    onToggleFullScreen,
    onSeek,
    onSeekMouseDown,
    onSeekMouseUp,
    // onNext,
  } = props;

  const {
    playing,
    muted,
    volume,
    playbackRate,
    played,
    playedSeconds,
    isFullscreen,
    seeking,
    // showNextBtn,
  } = state;

  const [conClassName, setConClassName] = useState();
  const [timeoutId, setTimeoutId] = useState();

  const handleHideControl = () => {
    clearTimeout(timeoutId);
    setConClassName("opacity-100");

    const id = setTimeout(() => {
      setConClassName(styles.hideContainer);
    }, 3000);
    setTimeoutId(id);
  };

  const timeSlider = (
    <Slider
      min={0}
      max={1000}
      step={1}
      value={played * 1000}
      allowCross={false}
      onChange={(value) => {
        onSeek(value);
      }}
      startPoint={0}
      onBeforeChange={() => onSeekMouseDown()}
      onAfterChange={(value) => onSeekMouseUp(value)}
      railStyle={{ height: "8px" }}
      trackStyle={{ backgroundColor: "#ed2a26", height: "8px" }}
      handleStyle={{
        cursor: "pointer",
        border: "none",
        backgroundColor: "#ed2a26",
        width: "16px",
        height: "16px",
        boxShadow: "none",
        opacity: 1,
      }}
    />
  );

  const volumeControl = (
    <div className={styles.volumeControl}>
      <button onClick={onMuted} className="mr-2">
        {muted || volume === 0 ? (
          <i className="bi bi-volume-mute-fill"></i>
        ) : (
          <i className="bi bi-volume-up-fill"></i>
        )}
      </button>
      <Slider
        min={0}
        max={100}
        step={1}
        startPoint={0}
        value={muted ? 0 : volume * 100}
        onChange={(value) => onChangeVolume(value)}
        railStyle={{ height: "6px" }}
        trackStyle={{ backgroundColor: "#ed2a26", height: "6px" }}
        handleStyle={{
          cursor: "pointer",
          border: "none",
          backgroundColor: "#ed2a26",
          width: "16px",
          height: "16px",
          boxShadow: "none",
          opacity: 1,
        }}
        className={styles.volumeSlider}
      />
    </div>
  );

  const seekingTime = played * totalTimes;

  return (
    <div
      className={clsx(
        styles.container,
        !playing && "opacity-100",
        conClassName
      )}
      onMouseMoveCapture={handleHideControl}
    >
      <div className={styles.centerControl}>
        <div className={styles.overlayPlayPause} onClick={onPlayPause}></div>

        {/* {showNextBtn && <button onClick={onNext}>Next</button>} */}

        <button onClick={onPlayPause} className={styles.btnPlayPause}>
          {playing ? (
            <i className="bi bi-pause-fill"></i>
          ) : (
            <i className="bi bi-play-fill"></i>
          )}
        </button>
      </div>
      <div className={styles.bottomControl}>
        {timeSlider}
        <div className={styles.mainControl}>
          <div className="d-flex align-items-center gap-2">
            <button onClick={onPlayPause}>
              {playing ? (
                <i className="bi bi-pause-fill"></i>
              ) : (
                <i className="bi bi-play-fill"></i>
              )}
            </button>
            <button onClick={onRewind}>
              <i className="bi bi-arrow-counterclockwise"></i>
            </button>
            <select
              aria-label="Default select example"
              value={playbackRate}
              className={styles.speedControl}
              onChange={(e) => onChangePlaybackRate(e.target.value)}
            >
              {[0.5, 1, 1.5, 2].map((item) => {
                return (
                  <option key={item} value={item}>
                    {item}x
                  </option>
                );
              })}
            </select>
            <button onClick={onFastForward}>
              <i className="bi bi-arrow-clockwise"></i>
            </button>
            {volumeControl}
            <div className={styles.timer}>
              {seeking
                ? formatTimeHMS(seekingTime)
                : formatTimeHMS(playedSeconds)}{" "}
              / {formatTimeHMS(totalTimes)}
            </div>
          </div>
          <div>
            <button
              onClick={onToggleFullScreen}
              className={styles.fullscreenControl}
            >
              {isFullscreen ? (
                <i className="bi bi-fullscreen-exit"></i>
              ) : (
                <i className="bi bi-fullscreen"></i>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

/* required: display name */
VideoControl.displayName = "VideoControl";

/* required: props types */
VideoControl.propTypes = {};

/* required: default props */
VideoControl.defaultProps = {};

export { VideoControl };
